var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnhold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3948_1687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50003 15.5C11.6421 15.5 15.0001 12.1421 15.0001 7.99997C15.0001 3.85782 11.6421 0.5 7.50003 0.5C3.35793 0.5 0 3.85788 0 8.00003C0 12.1422 3.35788 15.5 7.50003 15.5ZM7.50003 1.69999C10.9737 1.69999 13.8 4.52627 13.8 7.99997C13.8 11.4737 10.9737 14.3 7.50003 14.3C4.02632 14.3 1.20004 11.4737 1.20004 7.99997C1.20004 4.52627 4.02599 1.69999 7.50003 1.69999Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10622 11.5379C6.5205 11.5379 6.85624 11.2022 6.85624 10.7879V5.08791C6.85624 4.67363 6.52056 4.33789 6.10622 4.33789C5.69194 4.33789 5.3562 4.67357 5.3562 5.08791V10.7879C5.3562 11.2022 5.69188 11.5379 6.10622 11.5379Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10617 11.5379C9.52045 11.5379 9.85619 11.2022 9.85619 10.7879V5.08791C9.85619 4.67363 9.5205 4.33789 9.10617 4.33789C8.69183 4.33789 8.3562 4.67363 8.3562 5.08791V10.7879C8.3562 11.2022 8.69188 11.5379 9.10617 11.5379Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3948_1687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "currentcolor",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnhold);
export default __webpack_public_path__ + "static/media/onhold.b2aa58bc852c335889d74850c201f272.svg";
export { ForwardRef as ReactComponent };